import React, { useState } from "react";
import Logo from "../../images/logo1.jpg";
import { useNavigate } from "react-router-dom";
import "./login.css";
import ForgotPass from "./Forgotpass"; // Import the Forgot Password component
import OtpInput from "./OtpInput"; // Import the OTP Input component
import { BASE_URL } from "../../Globalapi/Globalapi";

const Log = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false); // State for showing OTP input
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      // const data = await response.text(); // get raw response
      console.log("Raw login response:", data);
      if (data.success) {
        sessionStorage.setItem("jwt", data.jwt);
        sessionStorage.setItem("user_id", data.user_id);
        sessionStorage.setItem("user_type", data.user_type);
        sessionStorage.setItem("school_id", data.school_id);
        sessionStorage.setItem("student_id", data.student_id);
        sessionStorage.setItem("staff_id", data.staff_id);
        sessionStorage.setItem("cmp_id", data.school_id);

        const userType = data.user_type;
        let redirectTo = "/";

        if (userType === "1") {
          redirectTo = "/admin";
        } else if (userType === "2") {
          redirectTo = "/staff";
        } else if (userType === "3") {
          redirectTo = "/student";
        } else if (userType === "4") {
          redirectTo = "/guardian";
        }

        navigate(redirectTo, { replace: true });
        // window.location.reload();
      } else {
        setError("Invalid email or password.");
      }
    } catch (error) {
      setError("An error occurred during login. Please try again.");
    }
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setShowOtpInput(false); // Reset OTP input visibility
  };

  const handleSendOtp = () => {
    setShowForgotPassword(false);
    setShowOtpInput(true); // Show OTP input component
  };

  return (
    <div className="login-container">
      <div className="logo-container">
        <img src={Logo} alt="Logo" className="logo" />
      </div>
      {showOtpInput ? (
        <OtpInput onBack={handleBackToLogin} /> // Render OTP input component
      ) : showForgotPassword ? (
        <ForgotPass onBack={handleBackToLogin} onSendOtp={handleSendOtp} /> // Render forgot password component
      ) : (
        <>
          <h2 style={{ textAlign: "center" }}>Welcome</h2>
          <p style={{ textAlign: "center" }}>
            Please enter your details to sign in
          </p>
          {error && (
            <p className="error-message" style={{ color: "red" }}>
              {error}
            </p>
          )}
          <form onSubmit={handleSubmit}>
            <label
              className="form-label"
              style={{ marginTop: "10px", display: "block" }}
            >
              Email Address / Username
            </label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%", // Full width inputs
                padding: "10px", // Padding inside inputs
                marginTop: "5px", // Space above inputs
                border: "1px solid #ccc", // Border for inputs
                borderRadius: "4px", // Rounded corners for inputs
              }}
            />
            <label
              className="form-label"
              style={{ marginTop: "10px", display: "block" }}
            >
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%", // Full width inputs
                padding: "10px", // Padding inside inputs
                marginTop: "5px", // Space above inputs
                border: "1px solid #ccc", // Border for inputs
                borderRadius: "4px", // Rounded corners for inputs
              }}
            />
            {/* <div className="remember-forgot" style={{
          display: 'flex', // Flexbox for alignment
          justifyContent: 'space-between', // Space between links
          marginTop: '10px', // Space above
        }}>
          <a href="/vimalagiri/forgot_pass" style={{ textDecoration: 'none', color: '#007bff' }}>Forgot Password?</a>
        </div> */}
            <div className="remember-forgot">
              <button
                type="button"
                className="forgot-password-button"
                onClick={handleForgotPasswordClick}
              >
                Forgot Password?
              </button>
            </div>
            <button
              type="submit"
              className="signin-button"
              style={{
                width: "100%", // Full width button
                padding: "10px", // Padding inside button
                marginTop: "20px", // Space above button
                backgroundColor: "#319795", // Button background
                color: "white", // Text color
                border: "none", // Remove border
                borderRadius: "4px", // Rounded corners for button
                cursor: "pointer", // Pointer on hover
              }}
            >
              Sign In
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default Log;
